import React from 'react';
import { Redirect } from 'expo-router';

// Keep saved links working; ideas now live in For you on New Chat.
export default function IdeasPage() {
  return <Redirect href="/app" />;
}
